import template from './in-house.jade';

export default angular.module('cian.addForm.inHouse', []).directive('cianAfAboutBuildingInHouse', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [function () {}],
  controllerAs: 'inHouse',
  template,
})).name;
